var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{on:{"click":_vm.navigate}},[_c('v-icon',{staticClass:"pr-2"},[_vm._v("mdi-file")]),_vm._v("\n  "+_vm._s(_vm.title)+"\n")],1)}
var staticRenderFns = []

export { render, staticRenderFns }